import { Page } from '@components/page';
import { Seo } from '@components/Seo';
import { Button } from '@components/ui/Button';
import Box from '@components/ui/layout/Box';
import SmallContainer from '@components/ui/layout/SmallContainer';
import { ChangelogItem } from '@components/_changelog/ChangeLogItem';
import { ChangelogPageIntro } from '@components/_changelog/Intro';
import { CHANGELOG_ITEMS_PAGE_LIMIT, getChangelogItems, getSanityClient } from '@lib/sanity/client';
import { useIsMounted } from '@lib/use-is-mounted';
import { GetStaticPaths, GetStaticProps, NextPage } from 'next';
import Link from 'next/link';
import React from 'react';
import { ChangelogItem as ChangelogItemModel, ChangelogSingleton } from '__generated__/sanity';
type ChangelogPageProps = {
  content: ChangelogSingleton;
  items: ChangelogItemModel[];
  total: number;
  current: number;
};
const ChangelogPage: NextPage<ChangelogPageProps> = ({
  content,
  total,
  items,
  current
}) => {
  const hasPrev = current > 0;
  const hasNext = current * CHANGELOG_ITEMS_PAGE_LIMIT + items.length < total;
  const isMounted = useIsMounted();
  return <Page>
      <Seo data={content.fields.seo} />
      <SmallContainer className={fadeIn} data-visible={isMounted ? '' : undefined}>
        <section className={grid}>
          <ChangelogPageIntro {...content.fields.intro} lastUpdateDate={items[0].date} />
          {items.map((item, index) => <ChangelogItem key={item._id} isLast={index === CHANGELOG_ITEMS_PAGE_LIMIT - 1} {...item} />)}
          {(hasNext || hasPrev) && <Box display="flex" justifyContent={hasPrev && hasNext ? 'space-between' : hasPrev ? 'flex-start' : 'flex-end'} my={{
          _: '64',
          md: '80',
          lg: '104'
        }}>
              {hasPrev && <Link href={`/changelog/page/${current}`}>
                  <Button>Previous page</Button>
                </Link>}
              {hasNext && <Link href={`/changelog/page/${current + 2}`}>
                  <Button>Next page</Button>
                </Link>}
            </Box>}
        </section>
      </SmallContainer>
    </Page>;
};
export default ChangelogPage;
export const getStaticProps: GetStaticProps<ChangelogPageProps, {
  index: string;
}> = async ({
  preview = false,
  params
}) => {
  if (!params || !params.index) {
    return {
      notFound: true
    };
  }
  const current = parseInt(params.index, 10) - 1;
  const sanity = getSanityClient(preview);
  const query = `*[_type == "changelog-singleton"]`;
  const queryResult = await sanity.fetch(query);
  const draft = queryResult.find(item => item._id.startsWith('drafts.'));
  const content = preview ? draft || queryResult[0] : queryResult[0];
  const {
    items,
    total
  } = await getChangelogItems(current, preview);
  return {
    props: {
      content,
      items,
      total,
      current
    }
  };
};
export const getStaticPaths: GetStaticPaths<{
  index: string;
}> = async () => {
  const {
    total
  } = await getChangelogItems();
  const pages = Math.ceil(total / CHANGELOG_ITEMS_PAGE_LIMIT);
  let paths = [];
  for (let i = 0; i < pages; i++) {
    paths.push(`/changelog/page/${i + 1}`);
  }
  return {
    paths,
    fallback: false
  };
};
const fadeIn = "f1v794rt";
const grid = "g1ckdgod";

require("./[index].linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./[index].tsx");